import { IAuthServiceV2 } from '@volkswagen-onehub/authservice';
import { NoMessagesFoundError } from './errors/NoMessagesFoundError';

export interface IVcfTransactionHistoryMessage {
    readonly category?: string;
    readonly timestamp?: string;
    readonly action?: string;
    readonly actionSuccess?: boolean;
    readonly alertName?: string;
    readonly keyName?: string;
    readonly keyUserName?: string;
}

export interface IVcfTransactionHistoryResponse {
    readonly data?: {
        readonly messages?: IVcfTransactionHistoryMessage[];
    };
}

// https://cardata.apps.emea.vwapps.io/documentation#tag/Transaction-History
export class VcfTransactionHistoryClient {
    
    private readonly resourceHostId: string;

    private getGdcType = (isWcar: boolean) => isWcar ? `myvw-wcar-${this.stage}` : `myvw-mbb-${this.stage}`;

    constructor(private readonly authServiceWeConnect: IAuthServiceV2, private readonly stage: string) {
        this.resourceHostId = `myvw-vcf-${stage}`
    }

    // https://cardata.apps.emea.vwapps.io/documentation#tag/Transaction-History/operation/transactionHistory
    public async getTransactionHistory(vin: string, isWcar: boolean): Promise<IVcfTransactionHistoryResponse> {
        const url = `vehicles/${vin}/transactionhistory?gdc=${this.getGdcType(isWcar)}`;
        const response = await this.authServiceWeConnect.get(this.resourceHostId, url,
            { 'User-Id': '__userId__' });

        if (response.status === 404) {
            throw new NoMessagesFoundError();
        }

        if (!response.ok) {
            throw new Error(`Request failed with status code ${response.status}`);
        }

        return await response.json() as IVcfTransactionHistoryResponse;
    }

    // https://cardata.apps.emea.vwapps.io/documentation#tag/Transaction-History
    public async deleteTransactionHistory(vin: string, isWcar: boolean, transactionCategory: string): Promise<void> {
        const url = `vehicles/${vin}/transactionhistory/${transactionCategory}?gdc=${this.getGdcType(isWcar)}`;
        let response;

        try {
            response = await this.authServiceWeConnect.delete(this.resourceHostId, url, undefined, { 'User-Id': '__userId__' });
        } catch (e) {
            throw e;
        }

        if (!response.ok) {
            throw new Error(`Request failed with status code ${response.status}`);
        }
    }

}